import anime from 'animejs/lib/anime.es.js';

export const initAccordionAsaidMenu = () => {
    // VARS
    const duration = 600;
    const activeClass = 'is-open-accordion';
    const rotateClass = '--rotate-img';
    const openClass = '--is-open';
    const btnImage = document.querySelector('[data-btn-img]');
    const bodyDocument = document.body;
    let isOpen = false;
    const toggles = document.querySelectorAll('[data-accordion-asaid-toggle]');
    if (!toggles.length) return;

    // LISTENER
    window.addEventListener('resize', handleTrackResize, false);

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', handleOnClick, false);
    });

    document.addEventListener('click', handleOutsideClick);

    // HANDLERS
    function handleOnClick() {
        const accordion = this.closest('[data-accordion-asaid]');
        if (window.innerWidth < 768) {
            accordion.classList.contains(activeClass) ? closeAccordion(accordion) : openAccordion(accordion);
        }
    }

    function handleOutsideClick(event) {
        const accordions = document.querySelectorAll('[data-accordion-asaid]');

        if (window.innerWidth < 768) {
            if (event.target.classList.value === 'hamburger__row' || !isOpen) return;
            accordions.forEach((accordion) => {
                if (!accordion.contains(event.target)) {
                    closeAccordion(accordion);
                }
            });
        }
    }

    // FUNCTIONS
    function openAccordion(accordion) {
        const body = accordion.querySelector('[data-accordion-asaid-body]');
        const height = body.scrollHeight;
        bodyDocument.classList.add(openClass);
        btnImage.classList.add(rotateClass);
        isOpen = true;

        anime({
            targets: body,
            height: [0, height],
            easing: 'linear',
            duration: duration,
            complete: function () {
                body.style.height = 'auto';
                accordion.classList.add(activeClass);
            },
        });
    }

    function closeAccordion(accordion) {
        const body = accordion.querySelector('[data-accordion-asaid-body]');
        const height = body.scrollHeight;
        body.style.height = `${height}px`;
        accordion.classList.remove(activeClass);
        btnImage.classList.remove(rotateClass);
        isOpen = false;

        anime({
            targets: body,
            height: 0,
            easing: 'linear',
            duration: duration,
            complete: function () {
                bodyDocument.classList.remove(openClass);
            },
        });
    }
    function handleTrackResize() {
        if (isOpen && window.innerWidth >= 768) {
            bodyDocument.classList.remove(openClass);
            document.removeEventListener('click', handleOutsideClick, false);
        }
    }
};
